<template>
  <div>
    <div class="main new newStudent-consultant-xyzx">
      <!-- <ul class="tabs">
        <li  class="active">我的学生</li>
        <li  @click="$router.push('/consultant/newstudent')" >新的学生</li>
      </ul> -->
      <div class="bg">
        <div class=" new" style="width:1000px; margin:0 auto">
          <div class="navInputs">
            <span>姓名</span> <el-input  v-model='name' placeholder="请输入内容" style="width:162px;height:32px"></el-input>
            <span>档案号</span> <el-input v-model='archives' placeholder="请输入内容" style="width:162px;height:32px"></el-input>
            <span>学校名称</span> <el-input v-model='school' placeholder="请输入内容" style="width:162px;height:32px"></el-input>
            <span>状态搜索</span>
            <el-select  style="width:162px;height:32px" v-model="fileStatusNumber" placeholder="请选择">
              <el-option
                  v-for="item in fileStatus"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
              </el-option>
            </el-select>
            <div class="common-search" @click="search">
              <img src="imgs/xueyezixun/admin/message/search.png" alt="">
              搜索
            </div>
          </div>
        </div>
        <div style="margin-top: 30px">
          <table>
            <tbody>
            <tr>
              <th>序号</th>
              <th>档案ID</th>
              <th>姓名</th>
              <th>性别</th>
              <th>所在学校</th>
              <th>状态</th>
              <th>操作</th>
            </tr>
            <tr v-for="(item,index) in studentData" :key="index">
              <td>{{index+1}}</td>
              <td>{{item.archives}}</td>
              <td>{{item.name}}</td>
              <td>{{item.sexName}}</td>
              <td>{{item.schoolName}}</td>
              <td>{{item.academicPlanningStatus}}</td>
              <td v-if=" (item.fileStatus==6||item.fileStatus==8)">
                <span class="unShow" >查看</span>
                <span class="unShow" style="margin-left: 10px">档案删除</span>
              </td>
              <td v-else>
                <span @click="goMyStudent(item)">查看</span>
                <span style="margin-left: 10px" @click="deleteArchives(item.studentId)">档案删除</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <Pages :page-data="options" :change="getMineStudentList"></Pages>
      <div style="margin-top:30px" v-if="studentData.length==0">
        <NoCotent></NoCotent>
      </div>
    </div>
  </div>
</template>
<script>
import Pages from '@/components/assembly/Pagination';
import NoCotent from '@/components/NoContent2';
export default {
  name: "index",
  data(){
    return {
      fileStatus:[
        { value:0, name:'全部'},
        { value:1, name:'已建档'},
        { value:4, name:'规划内容'},
        { value:5, name:'计划执行'},
        { value:6, name:'阶段评估'},
        { value:3, name:'档案删除审核中'},
        { value:2, name:'档案已删除'},
      ],
      fileStatusNumber:'',
      addStudents:0,
      studentData:[],
      title:['序号','档案ID','姓名','性别','所在学校','状态','操作'],
      keys:['xuhao','archives','name','sexName','school','academicPlanningStatus',null],
      options:{
        current:1,
        total:0,
        pageSize:10,
        totalPage:1
      },
      name:'',
      archives:'',
      school:''
    }
  },
  components:{ Pages ,NoCotent},
  methods:{
      goMyStudent(item) {
          window.sessionStorage.setItem('myStudentStudentId',item.studentId);
          window.sessionStorage.setItem('myStudentProvince',item.province);
          this.$router.push({path:'/consultant/minestudent/main',query:{studentId:item.studentId,id:item.id,name:item.name}})
      },
    search(){
      this.getMineStudentList()
    },
    // 档案删除申请
    deleteArchives(studentId){
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.deleteArchives, {
        studentId: studentId
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
            if (res.data.code == 2000) {
               this.getMineStudentList()
            }else{

            }
       })
    },
    getMineStudentList(pageNumber,pageSize){
      const options=this.options;
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.getList, {
        pageNumber:pageNumber||this.options.current,
        pageSize:pageSize||this.options.pageSize,
        name:this.name,
        archives:this.archives,
        fileStatus:this.fileStatusNumber==1?'':this.fileStatusNumber,
        school:this.school
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          let option = this.options;
          option.total= res.data.data.page.count;
          this.studentData=res.data.data.list||[];
          this.addStudents=res.data.data.newStudentCount||0;
        }else{

        }
      })
    }
  },
  mounted() {
    this.getMineStudentList(this.options.current,this.options.pageSize)
  }
}
</script>
<style  lang="less" scoped>
.main{
  width: 1200px;
  margin: 30px auto;
  background: #fff;
  padding: 0px 36px ;
  overflow: hidden;
  padding-top: 65px;
  .tabs{
    width: 280px;
    margin: 20px auto 40px;
    display: flex;
    justify-content: space-between;
    li{
      width: 110px;
      height: 32px;
      border-radius: 15px;
      font-size: 18px;
      text-align: center;
      line-height: 32px;
      color: #3d90f6;
      cursor: pointer;
    }
    .active{
      background: linear-gradient(305deg, #3d90f6 0%, #2CB2FF 100%, #5533FF 100%);
      box-shadow: 0px 6px 6px 0px rgba(0, 149, 235, 0.4);
      border-radius: 15px;
      color:#fff;
    }
  }
  .show{
    color:#1EA1EE;
    cursor: pointer;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
    &:hover {
      font-weight: bold;
    }
  }
  .unShow {
    color: #ABABAB;
    cursor: not-allowed;
  }
}
.new{
  font-size: 16px;
  .navInputs{
    &>span{
      margin-right: 8px;
    }
    input{
      margin-right: 12px;
      height:32px
    }
  }
}
.homeBox{
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 30px;
  overflow: hidden;
  .home{
    width: 960px;
    margin: 117px auto 50px;
    display: flex;
    justify-content: space-between;
    li{
      width: 180px;
      height: 220px;
      background: #FFFFFF;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      &>img{
        position: absolute;
        left: 0;
        top: 0;
      }
      .circle{
        width: 100px;
        height: 100px;
        background: rgba(0, 149, 235, 0.06);
        border-radius: 50%;
        margin: 40px auto 20px;
        padding-top: 30px;
        text-align: center;
      }
      p{
        font-size: 18px;
        font-weight: 500;
        color: #3d90f6;
        line-height: 25px;
        text-align: center;
      }
    }
  }
  .bottom{
    width: 330px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    li{
      width: 128px;
      height: 32px;
      line-height: 32px;
      background: #C8C6C6;
      box-shadow: 0px 4px 6px 0px rgba(196, 196, 196, 0.4);
      border-radius: 15px;
      text-align: center;
      font-size: 18px;
      color: #fff;
      cursor: pointer;
    }
    .newActive{
      color:#fff;
      background:#0094EA;
    }
  }
  .cancelButton{
    width:960px;
    margin: 60px auto 20px;
    textarea{
      height: 160px;
    }
  }

}
.hover{
  cursor: pointer;
  &:hover{
    color:#0A9BF0;
  }
}
table{
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  tbody{
    width: 100%;
  }
  tr{
    width: 100%;
    line-height: 40px;
    border-radius: 5px;
    border-bottom: 1px solid #ECECEC;
  }
  th{
    font-size: 16px !important;
    background: rgba(61, 144, 246, 0.1);
  }
  td,th{
    text-align: center;
    font-size: 14px;
    span{
      color: #1EA1EE;
      cursor: pointer
    }
  }
}
</style>
<style lang="less">
.newStudent-consultant-xyzx{
  
  min-height: 700px;
  .el-input__inner{
    height: 32px;
    border:1px solid #d9d9d9;
    border-radius: 0;
    line-height: 32px;
  }
  .el-input{
    margin-right: 12px;
  }
  .el-input__inner:focus{
    border-color:#409eff;
  }
  .el-input__icon{
    line-height: 32px;
  }
}
</style>